import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=50f9bd21&scoped=true"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/group_dashboard/view_user.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./UserList.vue?vue&type=style&index=1&id=50f9bd21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f9bd21",
  null
  
)

export default component.exports